<div class="history-backdrop" (click)="closed.emit()"></div>
<aside class="history-drawer editor-drawer" role="dialog" aria-modal="true" [attr.aria-label]="'editor.dialog' | transloco">
  <div class="history-heading">
    <div class="eyebrow">{{ 'editor.eyebrow' | transloco }}</div>
    <div class="heading-actions">
      <button type="button" mat-stroked-button [disabled]="savingSide() !== null" (click)="resetChanges()">{{ 'actions.reset' | transloco }}</button>
      <button type="button" mat-stroked-button (click)="closed.emit()">{{ 'actions.close' | transloco }}</button>
    </div>
  </div>
  <h2>{{ row().key }}</h2>
  <p class="history-hint">{{ 'editor.summary' | transloco:{ left: sideLabel('left'), right: sideLabel('right'), content: editLabel('left') } }}</p>
  @if (promptSide('left') || promptSide('right')) {
    <p class="history-hint">{{ 'editor.promptHint' | transloco }}</p>
  }
  <div class="compare-bar">
    <div class="env-field">
      <span>{{ 'compare.left' | transloco }}</span>
      <div class="env-seg" role="group" [attr.aria-label]="'compare.left' | transloco">
        @for (env of environments; track env.id) {
          <button type="button" [class.active]="chosenLeft() === env.id" [attr.aria-pressed]="chosenLeft() === env.id" [disabled]="!locked('right') && chosenRight() === env.id" (click)="chooseEnvironment('left', env.id)">{{ env.label }}</button>
        }
      </div>
    </div>
    @if (!locked('right')) {
      <button type="button" class="swap-button" (click)="swapEnvironments()" [attr.aria-label]="'actions.swap' | transloco"><mat-icon>swap_horiz</mat-icon></button>
      <div class="env-field">
        <span>{{ 'compare.right' | transloco }}</span>
        <div class="env-seg" role="group" [attr.aria-label]="'compare.right' | transloco">
          @for (env of environments; track env.id) {
            <button type="button" [class.active]="chosenRight() === env.id" [attr.aria-pressed]="chosenRight() === env.id" [disabled]="chosenLeft() === env.id" (click)="chooseEnvironment('right', env.id)">{{ env.label }}</button>
          }
        </div>
      </div>
    }
  </div>
  @if (editorError(); as notice) {
    <p class="history-error" role="alert">@if (notice.kind === 'key') { {{ notice.key | transloco }} } @else { {{ notice.text }} }</p>
  }
  <div class="editor-grid">
    <h3 class="editor-label editor-left-label">{{ sideLabel('left') }} · {{ editLabel('left') }}</h3>
    <h3 class="editor-label editor-right-label">{{ sideLabel('right') }} · {{ editLabel('right') }}</h3>
    <div class="editor-field editor-left-field">
      @if (promptSide('left')) {
        <app-prompt-editor name="left" [value]="leftDraft()" [syncKey]="leftSync()" (valueChange)="leftDraft.set($event)" (detailOpen)="leftDetail.set($event)" />
      } @else {
        <pre class="editor-gutter" #leftGutter [style.width.ch]="lineDigits(leftDraft())" aria-hidden="true">{{ lineNumbers(leftDraft()) }}</pre>
        <textarea #leftArea class="config-editor" [ngModel]="leftDraft()" (ngModelChange)="leftDraft.set($event); syncGutter(leftGutter, leftArea)" (scroll)="syncGutter(leftGutter, leftArea)" [attr.aria-label]="sideLabel('left') + ' ' + editLabel('left')"></textarea>
      }
    </div>
    <div class="copy-rail">
      <button type="button" class="copy-arrow" (click)="copyToLeft()" [attr.aria-label]="'actions.copyLeft' | transloco" [title]="'actions.copyLeft' | transloco"><mat-icon>arrow_back</mat-icon></button>
      <button type="button" class="copy-arrow" (click)="copyToRight()" [disabled]="locked('right')" [attr.aria-label]="'actions.copyRight' | transloco" [title]="'actions.copyRight' | transloco"><mat-icon>arrow_forward</mat-icon></button>
    </div>
    <div class="editor-field editor-right-field">
      @if (promptSide('right')) {
        <app-prompt-editor name="right" [value]="rightDraft()" [syncKey]="rightSync()" [readOnly]="locked('right')" (valueChange)="rightDraft.set($event)" (detailOpen)="rightDetail.set($event)" />
      } @else {
        <pre class="editor-gutter" #rightGutter [style.width.ch]="lineDigits(rightDraft())" aria-hidden="true">{{ lineNumbers(rightDraft()) }}</pre>
        <textarea #rightArea class="config-editor" [readonly]="locked('right')" [ngModel]="rightDraft()" (ngModelChange)="rightDraft.set($event); syncGutter(rightGutter, rightArea)" (scroll)="syncGutter(rightGutter, rightArea)" [attr.aria-label]="sideLabel('right') + ' ' + editLabel('right')"></textarea>
      }
    </div>
    <button type="button" class="editor-save editor-left-save" mat-flat-button color="primary" [disabled]="savingSide() !== null || leftDetail()" (click)="save('left')">{{ savingSide() === 'left' ? ('status.saving' | transloco) : ('actions.save' | transloco) }}</button>
    @if (!locked('right')) {
      <button type="button" class="editor-save editor-right-save" mat-flat-button color="primary" [disabled]="savingSide() !== null || rightDetail()" (click)="save('right')">{{ savingSide() === 'right' ? ('status.saving' | transloco) : ('actions.save' | transloco) }}</button>
    }
  </div>
  <div class="diff-heading">
    <div class="eyebrow">{{ 'editor.differences' | transloco }}</div>
    <div class="view-switch" role="group" [attr.aria-label]="'view.diff' | transloco">
      <button type="button" [class.active]="renderMode() === 'rendered'" [attr.aria-pressed]="renderMode() === 'rendered'" (click)="renderMode.set('rendered')">{{ 'view.rendered' | transloco }}</button>
      <button type="button" [class.active]="renderMode() === 'raw'" [attr.aria-pressed]="renderMode() === 'raw'" (click)="renderMode.set('raw')">{{ 'view.raw' | transloco }}</button>
    </div>
  </div>
  <div class="content-grid editor-diff">
    <section><h3>{{ sideLabel('left') }}</h3><app-diff-view [lines]="draftLines('left')" /></section>
    <section><h3>{{ sideLabel('right') }}</h3><app-diff-view [lines]="draftLines('right')" /></section>
  </div>
</aside>
@if (pendingSide(); as side) {
  <div class="confirm-backdrop" (click)="cancelSave()">
    <div class="confirm-dialog" role="alertdialog" aria-modal="true" [attr.aria-label]="'editor.confirmTitle' | transloco" (click)="$event.stopPropagation()" (keydown.escape)="cancelSave()">
      <div class="eyebrow">{{ 'editor.eyebrow' | transloco }}</div>
      <h2>{{ 'editor.confirmTitle' | transloco }}</h2>
      <p>{{ 'editor.confirm' | transloco:{ key: sideRow(side).key, content: editLabel(side), side: sideLabel(side) } }}</p>
      <div class="confirm-actions">
        <button type="button" mat-stroked-button (click)="cancelSave()">{{ 'actions.cancel' | transloco }}</button>
        <button type="button" mat-flat-button color="primary" (click)="confirmSave()">{{ 'actions.save' | transloco }}</button>
      </div>
    </div>
  </div>
}
